import axios from 'axios';

const CancelToken = axios.CancelToken;
const cancelAxiosRequest = CancelToken.source();

export { cancelAxiosRequest };